// extracted by mini-css-extract-plugin
export default {"menuBlock":"BC-z","title":"CC-z","nav":"DC-z","flexCell":"EC-z","facetLink":"FC-z"};